// extracted by mini-css-extract-plugin
export default {"container":"CategoryFilters__container--12jYJ","resetButton":"CategoryFilters__resetButton--rHfWq","option":"CategoryFilters__option--Qo8Ja"};